<template>
    <div class="row clearfix">
        <div class="filter_mainPagination col-6 clearfix">
            <div>
                <div class="radio_selectsGroup padding0 radio_selectGroupPagination"><span class="radio_selectsSelection"></span>
                    <label v-for="size in per_page" :ref="`${position}-page-${size}`" :id="`${position}-page-${size}`">
                        <input name="limit" class="radio_selectsInput" type="radio" :value="size" @change="updatePageSize(size)">
                        <span class="radio_labelLike">{{size}}</span>
                    </label>
                </div>
            </div>
            <label class="text-uppercase">{{lang('per_page')}}</label>
        </div>
        <div class="filter_mainPagination col-6 clearfix">
            <div class="pull-right">
                <ul class="pagination">
                    <!-- first page -->
                    <li v-if="value.page > 2"><a href="#" @click="goto(1)"><span class="fa fa-chevron-left"></span><span class="fa fa-chevron-left"></span></a></li>
                    <!-- previous page -->
                    <li v-if="value.page > 1" @click="prev"><a href="#"><span class="fa fa-chevron-left"></span> {{lang('prev')}}</a></li>
                    <!-- current page -->
                    <li class="active" v-if="hasData || !hasData && value.page != '1'"><a href="#">{{value.page}}</a></li>
                    <!-- next page -->
                    <li v-if="hasData && has_nextable_data" @click="next"><a href="#">{{lang('next')}} <span class="fa fa-chevron-right"></span></a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'np-pagination',
        props: {
            per_page: {
                default: () => [15, 25, 50, 100]
            },
            hasData: {},
            value: {},
            count: 0,

            position: {
                type: String,
                default: () => 'top',
            }
        },
        mounted: function () {
        },
        computed: {
            limit: function() {
                return this.value.limit;
            },
            has_nextable_data: function () {
                return this.count >= this.value.limit;
            }
        },
        methods: {
            updatePageSize: function (size) {
                this.$emit('input', {limit:size, page: this.value.page, next: true});
            },
            goto: function(page, is_next) {
                if (page > 0) {
                    this.$emit('input', {limit:this.value.limit, page: page, next: is_next, pagination_event: true}); //pagination_event is used in merchant filter for adding cursor requests
                }
            },
            prev: function () {
                this.goto(this.value.page - 1, false);
            },
            next: function () {
                this.goto(this.value.page + 1, true);
            }
        },
        watch: {
            limit: function(newValue) {
                const input = this.$refs['page-' + newValue];
                $(input).click(); // jquery animation from revolution javascript
            }

            // limit: function(newValue) {
            //     const input = this.$refs[`top-page-${newValue}`];
            //     //console.log(input)
            //     $(`top-page-${newValue}`).click(); // jquery animation from revolution javascript
            //     const bottom_input = this.$refs[`bottom-page-${newValue}`];
            //     // const input = this.$refs['top-page-' + newValue];
            //     //console.log(bottom_input)
            //     $(`bottom-page-${newValue}`).click(); // jquery animation from revolution javascript
            // }
        }
    }
</script>


